'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('property-show', {
      url: '/property/:id',
      template: '<property-show></property-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/property-show/property-show.routes.js